import AbstractProvider from '@src/services/App/AbstractProvider';
import {THEME_SET_DARK, THEME_SET_LIGHT, THEME_TOGGLE} from '@src/_redux/theme/constants';
import {getCssVarValue} from '@src/helpers/getCssVarValue';

export class ThemeProvider extends AbstractProvider {
    async boot(): Promise<void> {
        if (!document) {
            return;
        }

        this.app.make('store-events').listen([
            THEME_TOGGLE,
            THEME_SET_DARK,
            THEME_SET_LIGHT,
        ], () => {
            let meta = document.querySelector('meta[name="theme-color"]');
            if (!meta) {
                meta = document.createElement('meta');
                meta.setAttribute('name', 'theme-color');

                document.head.appendChild(meta);
            }

            meta.setAttribute('content', getCssVarValue('--header-bg'));
        });
    }
}
